import {Collapse} from "bootstrap";

export default class BusinessHours {
	businessHours: NodeListOf<HTMLElement>;

	constructor() {
		this.businessHours = document.querySelectorAll(".business-hours-wrapper");
		this.businessHours.forEach((el, index) => {
			const weekly = el.querySelector(".business-hours-weekly");

			if (weekly instanceof HTMLElement) {
				const collapse = new Collapse(weekly, {
					toggle: false
				});

				el.addEventListener('click', () => {
					if (weekly.classList.contains("show")) {
						collapse.hide();
					}
					else {
						collapse.show();
					}
				});
			}
		});
	}
}
